import { autoAttributesPlugin } from "@growthbook/growthbook/plugins";
import { GrowthBook, GrowthBookProvider } from "@growthbook/growthbook-react";
import { v4 as uuidv4 } from "uuid";
import { PropsWithChildren, useEffect, useState } from "react";
import { logger } from "@caju-beneficios/monitoring";

export function FeatureFlagProvider(props: PropsWithChildren) {
  const [featureFlagClient] = useState(
    () =>
      new GrowthBook({
        apiHost: "https://cdn.growthbook.io",
        clientKey: process.env.REACT_APP_GROWTH_BOOK_CLIENT_KEY,
        enableDevMode: process.env.REACT_APP_ENVIRONMENT !== "PRODUCTION",
        plugins: [autoAttributesPlugin()],
        trackingCallback: (experiment, result) => {
          logger.info({
            message: "Experiment Viewed",
            context: {
              experimentId: experiment.key,
              variationId: result.key,
            },
          });
        },
      }),
  );

  useEffect(() => {
    async function init() {
      try {
        const response = await featureFlagClient.init();

        let deviceId = localStorage.getItem("gb-deviceId");

        if (!deviceId) {
          deviceId = uuidv4();
          localStorage.setItem("gb-deviceId", deviceId);
        }

        featureFlagClient.setAttributes({
          id: deviceId,
          deviceId,
        });

        if (!response.success) throw response.error;
      } catch (error) {
        logger.error({
          message: "FeatureFlagProvider initialization failed",
          error: error as Error,
          context: {
            application: "quero-caju",
            component: "FeatureFlagProvider",
            service: "growthbook",
          },
        });
      }
    }

    init();
  }, [featureFlagClient]);

  return (
    <GrowthBookProvider growthbook={featureFlagClient}>
      {props.children}
    </GrowthBookProvider>
  );
}
